export default "__VITE_ASSET__Cnf6PICW__"